(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["interest-form"] && !Shopify.designMode) return;
  try {
    // The customer form cannot store a phone number, so it is added to the customer tags
  // (for example phone:0501234567) where it shows on the customer's profile.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form.interest-form__form')) return;
    var phoneInput = form.querySelector('[data-interest-phone]');
    var tagsInput = form.querySelector('input[name="contact[tags]"]');
    if (!phoneInput || !tagsInput) return;
    if (tagsInput.dataset.baseTags === undefined) tagsInput.dataset.baseTags = tagsInput.value;
    var phone = phoneInput.value.replace(/[^0-9+]/g, '');
    tagsInput.value = phone ? tagsInput.dataset.baseTags + ', phone:' + phone : tagsInput.dataset.baseTags;
  });
  } catch(e) { console.error(e); }
})();

})();
